export default __webpack_public_path__ + "static/Vienna_State_Opera_Vienna_Austria-a9493046c394930e6d9cefec599d9586.jpg";